import React, { useState, useEffect, useRef } from "react";
import logo from "../../assets/svg/logo.svg";
import add from "../../assets/svg/add.svg";
import brand from "../../assets/svg/brand.svg";
import dashboard from "../../assets/svg/dashboard.svg";
import download from "../../assets/svg/vdownload.svg";
import dock from "../../assets/svg/navdock.svg";
import help from "../../assets/svg/help.svg";
import issue from "../../assets/svg/issue.svg";
import N from "../../assets/svg/N.svg";
import notify from "../../assets/svg/notify.svg";
import report from "../../assets/svg/report.svg";
import galleryActive from "../../assets/svg/gallery_active.svg";
import galleryInactive from "../../assets/svg/gallery_inactive.svg";
import scan from "../../assets/svg/scan.svg";
import settings from "../../assets/svg/settings.svg";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import AddDock from "../dock/dockadd";
import QrScanner from "react-qr-barcode-scanner";
import ReportAnIssueModal from "../common/report-an-issue-modal";
import { getOrgLogoApi, getProfileDetailsApi, getOrgListApi } from "../Dashboard/dashboard-api";
import Dropdown from "react-bootstrap/Dropdown";

import { ReactComponent as SlotCloseIcon } from "../../assets/svg/close-1.svg";
import { ReactComponent as RefreshIcon } from "../../assets/svg/refresh-icon.svg";
import { getVehicleScanDataApi } from "../dock/dock-api";
import { Toast, ToastContainer } from "react-bootstrap";
import apple from "../../assets/svg/apple.svg";
import android from "../../assets/svg/android.svg";
import drop from "../../assets/svg/drop.svg";
import { useGlobal } from "../../GlobalContext";
import ProfilePopup from "./ProfilePopup";

const Navbars = () => {
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const googlePlayStore = process.env.REACT_APP_GOOGLE_PLAY_STORE;
  const applePlayStore = process.env.REACT_APP_APPLE_STORE;

  const { refreshDockList, setRefreshDockList, userType, rolePermissionList } = useGlobal();
  const [isAddDockModalOpen, setIsAddDockModalOpen] = useState(false);
  const windowWidth = window.innerWidth;
  const navigate = useNavigate();
  const [showComplaintModule, setShowComplaintModule] = useState(false);
  const [profileDetail, setProfileDetail] = useState({});
  const [orgLogo, setOrgLogo] = useState("");
  const [firstLetter, setFirstLetter] = useState("");
  const dropdownDownloadRef = useRef(null);
  const [showDownload, setShowDownload] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [displayMessage, setDisplayMessage] = useState(null);
  const [isScannerActive, setIsScannerActive] = useState(true);
  const [scanDataResult, setScanDataResult] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [stopStream, setStopStream] = useState(false);
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const popupRef = useRef();
  const [hovered, setHovered] = useState(null);
  const [showProfile, setShowProfile] = useState(false);
  const [orgName, setOrgName] = useState("");
  // Close popup when clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    getOrgList();
    getOrgLogo();
    getProfileDetails();
  }, []);
  const [orgList, setOrgList] = useState([]);
  const getOrgList = async () => {
    console.log("Getting org list");
    const response = await getOrgListApi();
    console.log(response.data);
    if (response.status === 200) {
      console.log(response.data.orgs);
      if (response.data.success === true) {
        setOrgList(response.data.orgs ?? []);
      }
    }
  };
  const getOrgLogo = async () => {
    try {
      const response = await getOrgLogoApi();
      if (response.success === true) {
        /*  setheaderDetails(response.user ?? {}); */
        setOrgName(response.org_name ?? "....");
        setOrgLogo(response.image ?? "");
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getProfileDetails = async () => {
    const response = await getProfileDetailsApi();
    if (response.status === 200) {
      if (response.data.success === true) {
        setProfileDetail(response.data.user);
        setFirstLetter(response.data.user.first_name ? response.data.user.first_name.charAt(0) : "");
      }
    }
  };

  const handleError = (err) => {
    console.error("Scan error:", err);
    /* setErrorMessage("No QR code detected. Try again."); */
  };
  const openModal = () => {
    console.log("open modal called");

    setIsOpen(true);
    setStopStream(false);
    setIsScannerActive(true);
  };
  const restartScanner = () => {
    setDisplayMessage("Restarting scanner...");
    setIsScannerActive(false); // Unmount scanner
    setTimeout(() => setIsScannerActive(true), 100); // Remount scanner after a short delay
    setScanDataResult(null); // Reset the scan result
    setErrorMessage(null); // Clear any error messages
  };

  const closeModal = () => {
    setStopStream(true);
    setIsScannerActive(false);
    setIsOpen(false);
  };

  const handleScan = (result) => {
    console.log("scan data........", result);
    if (result) {
      setDisplayMessage("Please wait...");
      setStopStream(true);
      setIsScannerActive(false);
      console.log("scan data........", result.text);
      validateVehicleScanData(result.text);
    }
  };

  const validateVehicleScanData = async (qrTag) => {
    try {
      const response = await getVehicleScanDataApi(qrTag);
      console.log(response.data);
      if (response.data.success === true) {
        closeModal();
        setScanDataResult(response.data.data);
        setIsAddDockModalOpen(true);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };

  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.1)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0)",
      width: "365px",
      height: "474px",
      textAlign: "center",
    },
  };
  const onSuccessDock = async (response) => {
    setScanDataResult(null);
    setIsAddDockModalOpen(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    setRefreshDockList(!refreshDockList);
  };

  const hasMenuPermission = (menuId) => {
    if (!rolePermissionList || rolePermissionList.length === 0) return true; // Default to true if not loaded yet to avoid flickering, or false if strict
    const menu = rolePermissionList.find((item) => item.menu_id === menuId);
    return menu ? menu.menu_permission : false;
  };

  return (
    <>
      <div className="header_con">
        <div className="head_left">
          <div>
            <img
              src={logo}
              style={{ height: "22px", cursor: "pointer" }}
              alt="Home Icon"
              onClick={() => {
                window.open(accountsUrl, "_blank", "noopener,noreferrer");
              }}
            />
          </div>
          <div className="d-flex gap-3">
            <img src={orgLogo != null && orgLogo !== "" ? orgLogo : brand} className="org-logo" alt="dock logo" srcSet="" style={{ width: "100%", height: "32px", cursor: "pointer", marginLeft: "5px" }} />
          </div>

          {hasMenuPermission(28) && (
            <Link to="/dashboard/default" className={`left_divs ${["/dashboard/default", "/dashboard/default"].includes(location.pathname) ? "active_menu" : ""}`}>
              <img src={dashboard} alt="dashboard" srcSet="" />
              <span>Dashboard</span>
            </Link>
          )}

          {hasMenuPermission(29) && (
            <Link to="/dock" className={`left_divs ${["/dock"].includes(location.pathname) ? "active_menu" : ""}`}>
              <img src={dock} alt="dock" srcSet="" />
              <span>Docks</span>
            </Link>
          )}

          {/* {hasMenuPermission(184) && ( */}
            <Link to="/gallery" className={`left_divs ${["/gallery"].includes(location.pathname) ? "active_menu" : ""}`}>
              <img src={["/gallery"].includes(location.pathname) ? galleryActive : galleryInactive} alt="gallery" srcSet="" />
              <span>Gallery</span>
            </Link>
          {/* )} */}

          {hasMenuPermission(30) && (
            <Link to="/quick-report" className={`left_divs ${["/customized"].includes(location.pathname) ? "active_menu" : ""}`}>
              <img src={report} alt="report" srcSet="" />
              <span>Report</span>
            </Link>
          )}

          <div onClick={() => setIsAddDockModalOpen(true)}>
            <button type="button" className="head_btn">
              <img src={add} alt="add" srcSet="" />
              <span>Add</span>
            </button>
          </div>
        </div>

        <div className="head_right">
          <div className="right_divs">
            <button
              onClick={() => {
                setShowComplaintModule(true);
              }}
              type="button"
              className="right_divs"
            >
              <img src={issue} alt="issue" srcSet="" />
              <span>Report an issue</span>
            </button>
          </div>

          {/* <button type="button" className="right_divs">
          <span>Download App</span>
          <img src={download} alt="download" srcSet="" />
        </button> */}
          <div style={{ position: "relative", display: "inline-block" }} ref={popupRef}>
            <div
              onClick={() => setShowPopup(!showPopup)}
              style={{
                backgroundColor: "#f8f8f8",
                padding: "10px 16px",
                borderRadius: "12px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <div
                style={{
                  fontSize: "13px",
                  fontWeight: "500",
                  color: "#172b4d",
                }}
              >
                Download
              </div>
              <img src={drop} />
            </div>

            {/* Custom popup */}
            {showPopup && (
              <div
                style={{
                  borderRadius: "24px",
                  padding: "16px",
                  backgroundColor: "#ffffff",
                  width: "250px",
                  position: "absolute",
                  top: "150%",
                  right: "-100px",
                  boxShadow: "0px 6px 14px 0px #0000001A, 0px 25px 25px 0px #00000017, 0px 55px 33px 0px #0000000D, 0px 99px 39px 0px #00000003, 0px 154px 43px 0px #00000000",
                }}
              >
                <div
                  style={{
                    fontWeight: "700",
                    fontSize: "14PX",
                    color: "#172B4D",
                  }}
                >
                  Download Gate app for
                </div>
                <div
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    alignItems: "center",
                    gap: "32px",
                  }}
                >
                  <div
                    onMouseEnter={() => setHovered("android")}
                    onMouseLeave={() => setHovered(null)}
                    onClick={() => window.open("https://play.google.com/store/apps/details?id=com.mawalog.dock&hl=en", "_blank", "noopener,noreferrer")}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      minWidth: "88px",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: "16px",
                      borderRadius: "12px",
                      backgroundColor: hovered === "android" ? "#F2FFF7" : "#f7f8f9",
                    }}
                  >
                    <img src={android} style={{ width: "22px" }} />
                    <div
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        color: hovered === "android" ? "#2C8C53" : "#172B4D",
                      }}
                    >
                      Android
                    </div>
                  </div>

                  <div
                    onMouseEnter={() => setHovered("ios")}
                    onMouseLeave={() => setHovered(null)}
                    onClick={() => window.open("https://apps.apple.com/in/app/dock/id6478599013", "_blank", "noopener,noreferrer")}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      minWidth: "88px",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: "16px",
                      borderRadius: "12px",
                      backgroundColor: hovered === "ios" ? "#F2FFF7" : "#f7f8f9",
                    }}
                  >
                    <img src={apple} style={{ width: "22px" }} />
                    <div
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        color: hovered === "ios" ? "#2C8C53" : "#172B4D",
                      }}
                    >
                      IOS
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div>
            <button
              type="button"
              className="head_btn"
              style={{ width: "91px" }}
              onClick={() => {
                openModal();
              }}
            >
              <img src={scan} alt="scan" srcSet="" />
              <span>Scan</span>
            </button>
          </div>

          {/* <div>
          <img src={notify} alt="notify" srcSet="" />
        </div> */}
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate("/help");
            }}
          >
            <img src={help} alt="help" srcSet="" />
          </div>
          {(userType === "A" || userType === "SA") && (
            <div
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/dockmaster");
              }}
            >
              <img src={settings} alt="settings" srcSet="" />
            </div>
          )}
          <div
            onClick={() => {
              setShowProfile(!showProfile);
            }}
            style={{ cursor: "pointer" }}
          >
            {profileDetail.profile_image != null && profileDetail.profile_image !== "" && <img src={profileDetail.profile_image} style={{ width: "44px", height: "44px", borderRadius: "100%", backgroundColor: "#f7f8f9", objectFit: "cover" }} alt="Profile" />}
            {(profileDetail.profile_image == null || profileDetail.profile_image === "") && (
              <div
                style={{
                  width: "44px",
                  height: "44px",
                  borderRadius: "100px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#FFD2DB",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "700",
                    color: "#842234",
                  }}
                >
                  {firstLetter}
                </div>
              </div>
            )}
          </div>
          {showProfile && <ProfilePopup orgList={orgList} profileDetail={profileDetail} onClose={() => setShowProfile(false)} orgLogo={orgLogo} orgName={orgName} callProfileFunc={getProfileDetails} />}
        </div>

        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: /* isModalOpen ? "rgba(0, 0, 0, 0.5)" : */ "transparent",
            transition: "background-color 0.5s ease-in-out",
            zIndex: 999,
            pointerEvents: /* isModalOpen ? "auto" : */ "none",
          }}
        />
        {showComplaintModule && (
          <ReportAnIssueModal
            onSuccess={() => {
              setShowComplaintModule(false);
            }}
            onCancel={() => {
              setShowComplaintModule(false);
            }}
          />
        )}

        {isAddDockModalOpen && (
          <>
            <div
              className="position-fixed top-0 start-0 w-100 h-100"
              style={{
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 999,
              }}
            />
            <div
              className="position-fixed top-0"
              style={{
                right: 0,
                width: window.innerWidth <= 640 ? "100%" : window.innerWidth <= 1024 ? "80%" : "50%",
                height: "100%",
                backgroundColor: "#fff",
                zIndex: 1000,
                transition: "right 0.5s ease-in-out",
                boxShadow: "-2px 0 10px rgba(0, 0, 0, 0.1)",
                overflowY: "auto",
                padding: "20px",
              }}
            >
              <AddDock
                scanDataResult={scanDataResult}
                onSuccess={onSuccessDock}
                onClose={() => {
                  setScanDataResult(null);
                  setIsAddDockModalOpen(false);
                }}
              />
            </div>
          </>
        )}

        {isOpen && (
          <div style={modalStyle.overlay}>
            <div style={modalStyle.modal}>
              <div style={{ color: "#ffffff" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#1E1E1E",
                      }}
                    >
                      Place the QR code inside the area
                    </div>
                  </div>
                </div>

                <div>
                  <div
                    style={{
                      width: "320px",
                      height: "320px",
                      textAlign: "center",
                    }}
                  >
                    {isScannerActive ? (
                      <QrScanner
                        className="qr-image-wrapper"
                        width={320}
                        height={320}
                        onUpdate={(err, result) => {
                          console.log("scan data........", result);
                          if (result) handleScan(result);
                          else handleError(err);
                        }}
                        style={{
                          width: "320px",
                          height: "320px",
                          borderRadius: "16px",
                          overflow: "hidden", // optional, to keep corners clean
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width: "320px",
                          height: "320px",
                          color: "#1E1E1E",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {displayMessage}
                      </div>
                    )}
                    {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
                  </div>
                  <div
                    style={{
                      marginTop: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <SlotCloseIcon
                      onClick={closeModal}
                      style={{
                        cursor: "pointer",
                        width: "48px",
                        height: "48px",
                      }}
                    />{" "}
                    <RefreshIcon
                      onClick={restartScanner}
                      style={{
                        cursor: "pointer",
                        width: "48px",
                        height: "48px",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default Navbars;
